export const ProjectData = [
    {
        id: 1,
        title: "Video Chat app",
        about: "This is the basic Video Chatting application for one to one conversation. The application uses the concept of the peer to peer connection and socket programming.",
        tags: ["React js", "socket.io", "peer-to-peer"],
        demo: "https://ankit1509.github.io/Video-Chat-app/",
        github: "https://github.com/ankit1509/Video-Chat-app",
        image: "https://user-images.githubusercontent.com/60814508/135123959-9dc965a3-d46d-462a-bc72-39363d80dd1d.png",    
    },
    {
        id: 2,
        title: "Password Management System",
        about: "This is a simple and simple and secure Password Management System made completely in Python. In Which the entire program is authenticated with one Global Password - so you don't have to remember individual passwords of your accounts, just remember one - and we'll take care of the rest.",
        tags: ["Python", "PyQT", "sqlite"],
        github: "https://github.com/ankit1509/password-Management-System",
        image: "https://user-images.githubusercontent.com/60814508/145575095-f08497d0-ce04-4d78-9d8b-4836d6be8950.png",    
    },
    {
        id: 3,
        title: "VMediaPlayer",
        about: "A simple media player for both audio and video files and simple editing. Which is named as VMediaPlayer. This have all the features required in a media player.",
        tags: ["Python", "PyQT", "Audio-Video-Processing", "QtDesigner"],
        github: "https://github.com/VCF-Small/VMediaPlayer",
        image: "https://user-images.githubusercontent.com/60814508/145612891-f614c4b0-2937-4428-ba54-6b01afd46dd8.png",    
    },
    {
        id: 4,
        title: "PhysicsVeda",
        about: "It is a portfolio for the Physics Lectures. It consists of the Video Lectures of the Physics, which are fetched from the Youtube API's.",
        tags: ["Angular", "Youtube API's"],
        demo: "https://ankit1509.github.io/PhysicsVeda/",
        github: "https://github.com/ankit1509/PhysicsVeda",
        image: "https://user-images.githubusercontent.com/60814508/165561938-e81c3770-be6c-4347-b797-b88e75d0fdd7.png",    
    },
    {
        id: 5,
        title: "ToDO App",
        about: "It is the task management System. It have the Functionality's like Add the Task, Delete the Task on the Completions of the Task.",
        tags: ["React js", "local-storage"],
        demo: "https://ankit1509.github.io/ToDo-app/#/",
        github: "https://github.com/ankit1509/ToDo-app",
        image: "https://user-images.githubusercontent.com/60814508/165563407-f9434e6e-f449-49cf-b85b-4cf20ab10d73.png",    
    },
    {
        id: 6,
        title: "vNumber-Check npm Package",
        about: "It is the npm package that provides the functionality of finding the given number isArmstrong, isEven, isOdd, isPalindrome, isPerfect or not.",
        tags: ["npm", "npm-package", "Node js"],
        demo: "https://ankit1509.github.io/vNumber-Check/global.html",
        github: "https://github.com/ankit1509/ToDo-app",
        image: "https://user-images.githubusercontent.com/60814508/165565722-c4e9f0d5-556b-4f41-9641-6ca6f7727cf8.png",    
    },
    {
        id: 7,
        title: "Web-Editor",
        about: "Web Editor is the simple editor interface that can be used for the HTML, CSS, and JavaScript Editor. It also includes the ability to produce the output of the code that will be written in the editor window simultaneously, which helps in the development of the web application. It is very useful for the beginner developers in learning the web development.",
        tags: ["editor", "React js", "codemirror", "codemirror-editor", "codemirror2"],
        demo: "https://ankit1509.github.io/WebEditor/",
        github: "https://github.com/ankit1509/WebEditor",
        image: "https://user-images.githubusercontent.com/60814508/165567337-cd674197-df64-4481-80be-c3828fc3c540.png",    
    },
    {
        id: 8,
        title: "vcompiler",
        about: "It is the npm package for the compilation of the code. Currently it supports the programming languages like C, C++, Python language. It can be used for the compilation of the code with or without the input.",
        tags: ["Node js","npm", "compiler", "npm-package", "online-compiler"],
        demo: "https://ankit1509.github.io/Compiler_package/",
        github: "https://github.com/ankit1509/Compiler_package",
        image: "https://user-images.githubusercontent.com/60814508/165569315-923b1e1c-0cd6-4bfb-bb2f-a6375bb970a7.png",    
    },
    {
        id: 9,
        title: "ArrowBrand",
        about: "It is the E-commerce Application with all the integrations of payment System and the database Connectivity's. It have the Stripe integrations for the payment system.",
        tags: ["React js","firebase", "Stripe"],
        demo: "https://ecommerce-9d058.web.app/",
        github: "https://github.com/ankit1509/Trad-Project",
        image: "https://user-images.githubusercontent.com/60814508/165571441-55c54675-5aae-4188-8603-f49106a2e006.png",    
    },
]